/** Dispatched when Pair Account/Subscription should open on the already-mounted accounts page. */
export const OPEN_PAIR_ACCOUNT_EVENT = "cloudcatcher:open-pair-account";

/** Set before navigating to /configuration/accounts so the page opens the pair wizard on mount. */
export const OPEN_PAIR_ACCOUNT_STORAGE_KEY = "cloudcatcher:open-pair-account";

/**
 * Opens the existing Pair Account / Pair Subscription wizard.
 * Navigates to Cloud Accounts when needed; does not change page UI.
 */
export function requestOpenPairAccount(history, location) {
  const path = (location?.pathname?.replace(/\/$/, "") || "/").toLowerCase();
  const onAccountsPage = path === "/configuration/accounts";

  if (onAccountsPage) {
    window.dispatchEvent(new CustomEvent(OPEN_PAIR_ACCOUNT_EVENT));
    return;
  }

  try {
    sessionStorage.setItem(OPEN_PAIR_ACCOUNT_STORAGE_KEY, "1");
  } catch (e) {
    // ignore storage failures; navigation still proceeds
  }
  history.push("/configuration/accounts");
}
